import { Backdrop, CircularProgress } from "@mui/material";

type LoadingBackgroundProps = {
  open?: boolean;
};
export const LoadingBackground = ({ open = false }: LoadingBackgroundProps) => (
  <Backdrop
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={open}
  >
    <CircularProgress color="secondary" />
  </Backdrop>
);
